import { RouteRecordRaw } from 'vue-router';

let routes: RouteRecordRaw[] = [
    {
        path: '/villageTrips',
        name: 'villageTrips',
        meta: { sideMenuLabel: "Escursioni" },
        component: () => import("./views/villageTrips.vue")
    },
    {
        path: '/villageTrip/:identifier',
        name: 'villageTripDetail',
        component: () => import("./views/villageTripDetail.vue")
    },
    {
        path: '/villageTripBookRequests',
        name: 'villageTripBookRequests',
        meta: { sideMenuLabel: "Richieste di prenotazione" },
        component: () => import("./views/villageTripBookRequests.vue")
    },
];

export default routes;